import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import ContentLayout from "../../Layout/ContentLayout";
import { getPipelineCreateRoute } from "./PipelineRoutes";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
import { SecondaryNavExternalLink, } from "../../UI/SecondaryNav/SecondaryNavButton";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import useHasPermission from "../../Hooks/useHasPermission";
import PipelineListTable from "../../Container/Pipeline/PipelineListTable";
export function PipelineList() {
    const virtualizedAppContext = useVirtualizedApp();
    const navButtons = [];
    const canManagePipelines = useHasPermission("CAN_MANAGE_PIPELINES");
    if (canManagePipelines) {
        navButtons.push(_jsx(SecondaryNavExternalLink, { icon: "plus", label: "New", title: "Create a new pipeline", href: getPipelineCreateRoute(), target: "_blank" }));
    }
    return (_jsx(SecondaryNavLayout, { nav: _jsx("div", { className: "d-flex", children: navButtons }), children: _jsx(ContentLayout, { paddingTop: true, className: "fullHeightMinusSecondaryNav pt-3 pb-4", children: _jsx(PipelineListTable, { virtualizedAppName: virtualizedAppContext.name, whereToLinkTo: "details" }) }) }));
}
